import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import ScrollToTop from './components/ScrollToTop';
import { BrowserRouter } from 'react-router-dom';
import LoadSpinner from './components/LoadSpinner.js';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
      <LoadSpinner />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
